import { CmpInternalEmailKeyEnum, CmpInternalEmailSettingFieldsFragment } from "../../../../../graphql/types";
import { ChamberSettingsFormState } from "../settingsData";

// IF13 Q-A (Moeen, Nov 2 2026): Global Settings > Invoicing Options "Add
// Chamber Email to Get the Copy of ..." and the Internal Emails cards "Sent
// Invoices" / "Paid Invoice Receipts" show and save one stored value: the card.
type PaymentsAndTaxes = ChamberSettingsFormState["paymentsAndTaxes"];
export type InvoiceCopyField = "paidInvoiceReceiptCopy" | "createdInvoiceCopy";
type Card = CmpInternalEmailSettingFieldsFragment;
export type InvoiceCopyCards = Partial<Record<InvoiceCopyField, Card>>;

export const invoiceCopyCardKeys: Record<InvoiceCopyField, CmpInternalEmailKeyEnum> = {
  paidInvoiceReceiptCopy: CmpInternalEmailKeyEnum.InvoicePaid,
  createdInvoiceCopy: CmpInternalEmailKeyEnum.InvoiceCreated,
};
const fields = Object.keys(invoiceCopyCardKeys) as InvoiceCopyField[];
const isValidEmail = (value: string) => /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/.test(value);
const normalize = (value: string) => value.trim().toLowerCase();

export const getInvoiceCopyCards = (cards?: Card[] | null): InvoiceCopyCards | null =>
  cards ? Object.fromEntries(fields.map(field => [field, cards.find(card => card.key === invoiceCopyCardKeys[field])])) : null;

/** The Global Settings fields show the card's Send To address. */
export const withInvoiceCopyCardEmails = (paymentsAndTaxes: PaymentsAndTaxes, cards: InvoiceCopyCards): PaymentsAndTaxes =>
  fields.reduce((current, field) => {
    const card = cards[field];
    if (!card) return current;
    const email = card.sendTo[0] || "";
    return current[field].email === email ? current : { ...current, [field]: { enabled: !!email, email } };
  }, paymentsAndTaxes);

/**
 * Global Settings saved a different address: save it to the card and turn the
 * card on. An unchanged address (any other Invoicing Options save) keeps the
 * card as it is, also when it is DISABLED.
 */
export const getInvoiceCopyCardUpdates = (paymentsAndTaxes: PaymentsAndTaxes, cards: InvoiceCopyCards) =>
  fields.flatMap(field => {
    const card = cards[field];
    const email = normalize(paymentsAndTaxes[field].email);
    if (!card || !email || !isValidEmail(email) || card.sendTo[0] === email) return [];
    return [{ key: card.key, enabled: true, sendTo: [email], expectedUpdatedAtUtcMilli: card.updatedAtUtcMilli ?? null }];
  });
